import {
  getReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
// import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  // emptySearchInfo: {
  //   searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
  //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
  //   searchMonthType: 'CURRENT', // CURRENT, TOTAL
  //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
  //   searchFeeId: '',
  //   searchPaymentId: ''
  // },
  // searchInfo: {
  //   // entityId: '',
  //   // projId: '',
  //   // compId: '',
  //   searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
  //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
  //   searchMonthType: 'CURRENT', // CURRENT, TOTAL
  //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
  //   // startDt: null,
  //   // endDt: null
  //   searchFeeId: '',
  //   searchPaymentId: ''
  // },
  // searchedForm: {
  //   // entityId: '',
  //   // projId: '',
  //   // compId: '',
  //   searchType: 'MONTH',
  //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
  //   searchMonthType: 'CURRENT', // CURRENT, TOTAL
  //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
  //   // startDt: new Date(0),
  //   // endDt: new Date(0)
  //   searchFeeId: '',
  //   searchPaymentId: ''
  // },
  // transList: [],
  // transInfo: {
  //   transId: '',
  //   colType: '',
  //   compId: '',
  //   projId: '',
  //   entityId: '',
  //   ctrAcctId: '',
  //   transDt: '',
  //   transSummary: '',
  //   contractAmt: 0,
  //   feeId: '',
  //   reimbOutputSettlAmt: 0,
  //   reimbOfficialSettlAmt: 0,
  //   payPlanAmt: 0,
  //   payDebtAmt: 0,
  //   payAmt: 0,
  //   paymentId: '',
  //   invAmt: 0,
  //   transIndex: '',
  //   docMonth: '',
  //   docIndex: 0,
  //   allowDuplicate: false,
  //   transRemarks: '',
  //   lockBy: '',
  //   lockOn: new Date(0),
  //   crtBy: '',
  //   crtOn: new Date(0),
  //   updBy: '',
  //   updOn: new Date(0),
  //   //
  //   indUsed: ''
  // },
  // editIndex: -1,
  // editAction: '',
  // editDocMonth: '',
  // editDocIndex: 0,
  // editAllowDuplicate: false,
  docMonthIndexList: [],
  docMonthIndexMap: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async findProjTransDocMonthIndexList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_PROJ_TRANS_DOC_MONTH_INDEX_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // state.searchedForm = data
    // commit('updateSearchedForm', data)
    commit('updateDocMonthIndexList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  //
  updateDocMonthIndexList(state, response) {
    if (response.success === true && response.data.length) {
      state.docMonthIndexList = response.data

      let map = {}
      state.docMonthIndexList.forEach((item, index) => {
        if (item.docMonthIndex) {
          map[item.docMonthIndex] = item
        }
      })
      state.docMonthIndexMap = map
    } else {
      state.docMonthIndexList = []
      state.docMonthIndexMap = {}
    }
  },
  updateDocMonthIndexListEmpty(state) {
    state.docMonthIndexList = []
    state.docMonthIndexMap = {}
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/transIndexManage.js